"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseLineageCountsQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var LineageCountsFunctions_1 = require("../lineage/LineageCountsFunctions");
function createUnfilteredCounts(data) {
    var _a, _b, _c;
    var database = data.databases && data.databases[0];
    if (database
        && database.unfilteredTablesConnection
        && database.upstreamDatabasesConnection
        && database.upstreamTablesConnection
        && database.upstreamFlowsConnection
        && database.upstreamDatasourcesConnection
        && database.downstreamDashboardsConnection
        && database.downstreamDatabasesConnection
        && database.downstreamTablesConnection
        && database.downstreamFlowsConnection
        && database.downstreamDatasourcesConnection
        && database.downstreamWorkbooksConnection
        && database.downstreamSheetsConnection
        && database.downstreamMetricsConnection
        && database.downstreamOwnersConnection) {
        return {
            filteredTableName: null,
            tables: database.unfilteredTablesConnection.totalCount,
            upstreamDatabases: database.upstreamDatabasesConnection.totalCount,
            upstreamTables: database.upstreamTablesConnection.totalCount,
            upstreamFlows: database.upstreamFlowsConnection.totalCount,
            upstreamDatasources: database.upstreamDatasourcesConnection.totalCount,
            downstreamDashboards: database.downstreamDashboardsConnection.totalCount,
            downstreamDatabases: database.downstreamDatabasesConnection.totalCount,
            downstreamTables: database.downstreamTablesConnection.totalCount,
            downstreamVirtualConnections: ((_a = database.downstreamVirtualConnectionsConnection) === null || _a === void 0 ? void 0 : _a.totalCount) || 0,
            downstreamVirtualConnectionTables: ((_b = database.downstreamVirtualConnectionTablesConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            downstreamFlows: database.downstreamFlowsConnection.totalCount,
            downstreamDatasources: database.downstreamDatasourcesConnection.totalCount,
            downstreamLenses: ((_c = database.downstreamLensesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            downstreamWorkbooks: database.downstreamWorkbooksConnection.totalCount,
            downstreamSheets: database.downstreamSheetsConnection.totalCount,
            downstreamMetrics: database.downstreamMetricsConnection.totalCount,
            downstreamOwners: database.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
function createFilteredCounts(data) {
    var _a, _b, _c, _d;
    var database = data.databases && data.databases[0];
    var filteredTable = database && database.filteredTablesConnection && database.filteredTablesConnection.nodes[0];
    if (database
        && database.unfilteredTablesConnection
        && filteredTable
        && filteredTable.upstreamDatabasesConnection
        && filteredTable.upstreamTablesConnection
        && filteredTable.upstreamFlowsConnection
        && filteredTable.upstreamDatasourcesConnection
        && filteredTable.downstreamDashboardsConnection
        && filteredTable.downstreamDatabasesConnection
        && filteredTable.downstreamTablesConnection
        && filteredTable.downstreamFlowsConnection
        && filteredTable.downstreamDatasourcesConnection
        && filteredTable.downstreamWorkbooksConnection
        && filteredTable.downstreamSheetsConnection
        && filteredTable.downstreamMetricsConnection
        && filteredTable.downstreamOwnersConnection) {
        return {
            filteredTableName: (_a = filteredTable === null || filteredTable === void 0 ? void 0 : filteredTable.name) !== null && _a !== void 0 ? _a : null,
            tables: database.unfilteredTablesConnection.totalCount,
            upstreamDatabases: filteredTable.upstreamDatabasesConnection.totalCount,
            upstreamTables: filteredTable.upstreamTablesConnection.totalCount,
            upstreamFlows: filteredTable.upstreamFlowsConnection.totalCount,
            upstreamDatasources: filteredTable.upstreamDatasourcesConnection.totalCount,
            downstreamDashboards: filteredTable.downstreamDashboardsConnection.totalCount,
            downstreamDatabases: filteredTable.downstreamDatabasesConnection.totalCount,
            downstreamTables: filteredTable.downstreamTablesConnection.totalCount,
            downstreamVirtualConnections: ((_b = filteredTable.downstreamVirtualConnectionsConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            downstreamVirtualConnectionTables: ((_c = filteredTable.downstreamVirtualConnectionTablesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            downstreamFlows: filteredTable.downstreamFlowsConnection.totalCount,
            downstreamDatasources: filteredTable.downstreamDatasourcesConnection.totalCount,
            downstreamLenses: ((_d = filteredTable.downstreamLensesConnection) === null || _d === void 0 ? void 0 : _d.totalCount) || 0,
            downstreamWorkbooks: filteredTable.downstreamWorkbooksConnection.totalCount,
            downstreamSheets: filteredTable.downstreamSheetsConnection.totalCount,
            downstreamMetrics: filteredTable.downstreamMetricsConnection.totalCount,
            downstreamOwners: filteredTable.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
var DatabaseLineageCountsQueryWrapper = function (props) {
    var _a = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext), publishedConnectionsLineageEnabled = _a.publishedConnectionsLineageEnabled, lensLineageEnabled = _a.lensLineageEnabled;
    var selectedTables = Object.keys(props.selectedTableKeys);
    if (selectedTables.length > 0) {
        var selectedTableId = selectedTables[0];
        return (react_1.default.createElement(components_1.Query, { query: queries_1.DatabaseLineageCountsFilteredByTableDocument, variables: {
                databaseId: props.databaseId,
                tableId: selectedTableId,
                publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
                lensLineageEnabled: lensLineageEnabled
            } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderFilteredLineageCounts)(result, createUnfilteredCounts, createFilteredCounts, props.children)); }));
    }
    else {
        return (react_1.default.createElement(components_1.Query, { query: queries_1.DatabaseLineageCountsDocument, variables: { databaseId: props.databaseId, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled, lensLineageEnabled: lensLineageEnabled } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderUnfilteredLineageCounts)(result, createUnfilteredCounts, props.children)); }));
    }
};
exports.DatabaseLineageCountsQueryWrapper = DatabaseLineageCountsQueryWrapper;
//# sourceMappingURL=DatabaseLineageCountsQueryWrapper.js.map